/**
 * IncomingCallModal Component for Device App
 * Shows incoming video call with large, senior-friendly buttons
 */
import React, { useEffect } from 'react';
import { Phone, PhoneOff } from 'lucide-react';
import { toast } from 'sonner';

function IncomingCallModal({
  callId,
  fromUserName,
  seniorName,
  onAccept,
  onReject,
}) {
  // Play ringtone (optional - could add audio element)
  useEffect(() => {
    console.log('[IncomingCallModal] Incoming call from:', fromUserName);
    // TODO: Add ringtone audio in future
  }, [fromUserName]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md">
      <div className="bg-neutral-900 border-4 border-[#6DCEE8] rounded-3xl shadow-2xl w-full max-w-2xl mx-8 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#6DCEE8] to-[#5B4B8A] px-8 py-6 text-center">
          <div className="animate-pulse">
            <Phone className="w-20 h-20 text-white mx-auto mb-4" />
          </div>
          <h2 className="text-4xl font-bold text-white mb-2">
            Eingehender Anruf
          </h2>
        </div>

        {/* Content */}
        <div className="p-12 text-center space-y-8">
          {/* Caller Info */}
          <div>
            <p className="text-white text-5xl font-bold mb-3">
              {fromUserName}
            </p>
            {seniorName && (
              <p className="text-neutral-400 text-2xl">
                ruft an
              </p>
            )}
            <p className="text-neutral-500 text-xl mt-4">
              Videoanruf
            </p>
          </div>

          {/* Buttons */}
          <div className="flex gap-6 justify-center pt-8">
            {/* Reject Button */}
            <button
              onClick={onReject}
              className="w-40 h-40 bg-red-600 hover:bg-red-700 text-white rounded-full font-bold text-2xl transition-all hover:scale-105 active:scale-95 flex flex-col items-center justify-center gap-3 shadow-lg shadow-red-600/50"
            >
              <PhoneOff className="w-16 h-16" />
              <span>Ablehnen</span>
            </button>

            {/* Accept Button */}
            <button
              onClick={onAccept}
              className="w-40 h-40 bg-green-600 hover:bg-green-700 text-white rounded-full font-bold text-2xl transition-all hover:scale-105 active:scale-95 flex flex-col items-center justify-center gap-3 shadow-lg shadow-green-600/50 animate-pulse"
            >
              <Phone className="w-16 h-16" />
              <span>Annehmen</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncomingCallModal;
